import { Box, Center, VStack } from "@chakra-ui/react"
import { FeatureList } from "../sidebar/FeatureList"
import * as gqlTypes from "@hydrologiq/gql-experience/graphql"

interface SidebarProps {
  collapsed: boolean
  onToggle?: () => void
  preferencesData?: gqlTypes.GetPreferencesQuery | null
  Chat: React.ReactNode
  position?: "fixed" | "relative"
  minimal?: boolean
}

export const Sidebar = ({ preferencesData, position = "fixed", Chat }: SidebarProps) => {
  const positionStyles =
    position === "fixed"
      ? { position: "fixed" as const, left: 0, top: 0, bottom: 0 }
      : { position: "relative" as const, height: "100%" }
  return (
    <>
      {/* Desktop Sidebar */}
      <Box
        // display={{ base: "none", lg: "block" }}
        {...positionStyles}
        width={{ base: "55px", md: "75px" }}
        transition="width 0.3s"
        zIndex={10}
        color="primary"
        padding={{ base: "3px", md: "5px" }}
        paddingTop={"0px !important"}
      >
        <VStack align="stretch" height="100%" gap={0} bg="sidebar" borderRadius="5px" border="1px solid" borderColor="nav_border">
          {/* Feature List */}
          <Box flex={1} overflow="auto" color="white">
            <FeatureList preferencesData={preferencesData} />
          </Box>
          <Center>{Chat}</Center>
        </VStack>
      </Box>
    </>
  )
}
